import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { TranslateModule } from "@ngx-translate/core";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { MatRadioModule } from "@angular/material/radio";
import { OwlDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { MobileFilterComponentModule } from "src/app/app/_component/_structural/mobile-filter/mobile-filter.module";
import { ReportFilterModalComponent } from "./report-filter-modal.component";

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    MatRadioModule,
    SelectDropdownModule,
    OwlDateTimeModule,
    MobileFilterComponentModule,
  ],
  declarations: [ReportFilterModalComponent],
  exports: [ReportFilterModalComponent],
})
export class ReportFilterModalComponentModule {}
